import { useQueryClient } from "react-query"

export function useClearQueryCache() {
  const queryClient = useQueryClient()

  async function clearQueryCache() {
    await queryClient.clear()
  }

  return {
    clearQueryCache,
  }
}
